export const environment = {
  production: false,
  // apiBaseUrl: 'https://consumer-api.livepass.com/api/v1'
  apiBaseUrl: 'https://staging-consumer-api.livepass.in/api/v1',
  // apiBaseUrl: 'https://preprod-consumer-api.livepass.in/api/v1'
  /** seats.io — public key only (never put secret workspace key in the browser). */
  seatsio: {
    region: 'eu' as const,
    workspaceKey: '102a1a9d-448a-4e75-bb58-4f7b9e3edd2d',
    /** Bookable event created from Peddi chart */
    eventKey: 'cbb8803f-81d9-4619-b32e-1f322e63beb6',
    chartKey: '8ebcbe49-097f-44d0-45f1-333960763a59'
  }
};
